export default __webpack_public_path__ + "static/media/6.d59d5a30.webp";